import * as React from 'react'

import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'

import * as theme from '../../../theme'

const CustomizeButton = styled(Button)({
  fontSize: 12,
  padding: '6px 6px',
  border: '1px solid',
  lineHeight: 1.5,
  color: theme.PRIMARY_BUTTON_FONT,
  backgroundColor: theme.PRIMARY_BUTTON,
  borderColor: theme.PRIMARY_BUTTON,
  borderRadius:20,
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  '&:hover': {
    backgroundColor: theme.PRIMARY_BUTTON,
    borderColor: theme.PRIMARY_BUTTON,
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: theme.PRIMARY_BUTTON,
    borderColor: theme.PRIMARY_BUTTON,
  },
  '&:disabled': {
    boxShadow: 'none',
    backgroundColor: theme.PRIMARY_BUTTON,
    borderColor: theme.PRIMARY_BUTTON,
  },
  '& .MuiButton-startIcon': {
    margin: 0,
  },
})



export default function ActionButton(props) {
  const {buttonText, ...rest }  = props
  return (
      <CustomizeButton variant="contained" {...rest}>
      </CustomizeButton>
  )
}